/**
 * GET /allocation-questionnaire/preference/details.
 *
 * Belongs here: path, axios, and React Query hook.
 * Does not belong here: preference mapping or answering session.
 */
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '../../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../../env'
import type { PreferencesQuestionnaireApiResponse } from '../preferences/setup/types'
import { PREFERENCES_QUESTIONNAIRE_QUERY_KEY } from './queryKeys'

export const PREFERENCES_QUESTIONNAIRE_PATH = `${mobileBackendUrl}/v2/portfolio/allocation-questionnaire/preference/details`

/** GET preferences questionnaire + preference list. */
export async function fetchPreferencesQuestionnaire(): Promise<PreferencesQuestionnaireApiResponse> {
  const response = await axiosInstance.get<PreferencesQuestionnaireApiResponse>(
    PREFERENCES_QUESTIONNAIRE_PATH
  )
  if (!response?.data) {
    throw new Error('Failed to fetch preferences questionnaire')
  }
  return response.data
}

/** Preferences questionnaire query — retry 1. */
export function usePreferencesQuestionnaireQuery() {
  return useQuery({
    queryKey: PREFERENCES_QUESTIONNAIRE_QUERY_KEY,
    queryFn: fetchPreferencesQuestionnaire,
    retry: 1
  })
}
